import React from 'react';
import PropTypes from 'prop-types';
import { useCreditAnalysisCardLogic } from './CreditAnalysisCardLogic';
import Card from '../../layout/Card/Card';
import Section from '../../layout/Section/Section';
import FormRow from '../../form/FormRow/FormRow';
import FormColumn from '../../form/FormColumn/FormColumn';
import NumericField from '../../form/NumericField/NumericField';
import SelectField from '../../form/SelectField/SelectField';
import { OPTIONS } from '../../../utils/constantes'

const CreditAnalysisCard = ({ setCreditAnalysisData, totalIncome = 0 }) => {

  const validTotalIncome = typeof totalIncome === 'number' && !isNaN(totalIncome) ? totalIncome : 0;
  
  const {
    rendaProponentes,
    valorFinanciado,
    tipoSimulacaoCredito,
    fgtsValue,
    subsidyValue,
    otherSubsidiesValue,
    handleRendaProponentesChange,
    handleValorFinanciadoChange,
    handleTipoSimulacaoCreditoChange,
    handleFgtsValueChange,
    handleSubsidyValueChange,
    handleOtherSubsidiesValueChange,
  } = useCreditAnalysisCardLogic(setCreditAnalysisData, validTotalIncome);

  return (
    <Card title="Financiamento">

      {/* Seção: Tipo de Simulação de Crédito */}
      <Section >
        <FormRow>
          <FormColumn>
            <SelectField
              id="tipoSimulacaoCredito"
              label="Tipo de Simulação de Crédito"
              value={tipoSimulacaoCredito}
              onChange={handleTipoSimulacaoCreditoChange}
              options={OPTIONS.TIPO_SIMULACAO}
            />
          </FormColumn>
          <FormColumn>
            <NumericField
              id="rendaProponentes"
              label="Renda Total dos Proponentes (R$)"
              value={rendaProponentes}
              onChange={handleRendaProponentesChange}
              readOnly={true}
              currency={true}
            />
          </FormColumn>
        </FormRow>
      </Section>

      {/* Seção: Parâmetros do Financiamento */}
      <Section title="Parâmetros do Financiamento" variant="subsection">
        <FormRow>
          <FormColumn cols={3}>
            <NumericField 
              id="valorFinanciado"
              label="Valor Financiado (R$)"
              value={valorFinanciado}
              onChange={handleValorFinanciadoChange}
              currency={true}
              required={true}
            />
          </FormColumn>
          <FormColumn cols={3}>
            <NumericField
              id="valorFGTS"
              label="Valor FGTS (R$)"
              value={fgtsValue}
              onChange={handleFgtsValueChange}
              currency={true}
            />
            </FormColumn>
            <FormColumn cols={3}>
              <NumericField
                id="valorSubsidio"
                label="Subsídio Caixa (R$)"
                value={subsidyValue}
                onChange={handleSubsidyValueChange}
                currency={true}
              />
            </FormColumn>
            <FormColumn cols={3}>
              <NumericField
                id="demaisSubsidio"
                label="Demais Subsídio (R$)"
                value={otherSubsidiesValue}
                onChange={handleOtherSubsidiesValueChange}
                currency={true}
              />
            </FormColumn>
        </FormRow>
      </Section>
    </Card>
  );
};

CreditAnalysisCard.propTypes = {
  setCreditAnalysisData: PropTypes.func.isRequired,
  totalIncome: PropTypes.number.isRequired,
};

export default CreditAnalysisCard;